// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selector_ADVRF {
  max-height: 300px !important;
  min-width: 150px;
}

.selectorContainer_rk1Dq {
  flex-grow: 1;
}

.blurHandler_YcEYB.table_Fc0B6 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/condition/AttributeConditionEditor.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb","sourcesContent":[".selector {\n  max-height: 300px !important;\n  min-width: 150px;\n}\n\n.selectorContainer {\n  flex-grow: 1;\n}\n\n.blurHandler.table {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selector": `selector_ADVRF`,
	"selectorContainer": `selectorContainer_rk1Dq`,
	"blurHandler": `blurHandler_YcEYB`,
	"table": `table_Fc0B6`
};
export default ___CSS_LOADER_EXPORT___;
